import React from "react";
// import { Link as Link2 } from "react-router-dom";
// import ModalVideo from "react-modal-video";
import { useNavigate } from "react-router-dom";
import Services from "../component/home-page/Services";
import About from "../component/home-page/About";
// import Pricing from "../component/Pricing";
import Blog from "../component/home-page/Blog";
import Contact from "../component/home-page/Contact";
// import Footer from "../component/Footer";
import Industries from "../component/home-page/Industries";
import Testimonial from "../component/home-page/Testimonial";
// import Switcher from "../component/Switcher";
// import Navbar from "../component/navbar";
import StartYourFreeTrial from "../component/home-page/StartYourFreeTrial";
import SattvaPresence from "../component/home-page/SattvaPresence";
import ESGFrameWork from "../component/home-page/ESGFrameWork";
import JoinSattva from "../component/home-page/JoinSattva";
import Partners from "../component/home-page/Partners";
import Hero from "../component/home-page/Hero";

export default function HomePage() {

    window.scrollTo(0, 0);
 
    return (
        <>
            <div>
                {/* <Navbar navdark={true} /> */}

                {/* Entry hero section */}
               
                <Hero />

                {/* About section */}
                <About />

                {/* Sattva Presence section */}
                <SattvaPresence />

                {/* Service/Application section */}
                <Services />

                {/* ESG framework section */}
                <ESGFrameWork />

                {/* Industries section */}
                <Industries />

                {/* Join saatva box */}
                <JoinSattva />

                {/* Testimonial section */}
                <Testimonial />

                {/* Pricing section */}
                {/* <Pricing /> */}

                {/* Blog section */}
                <Blog text={'Learn more about us'} h3Heading={'Latest Blogs and News'} />

                {/* Our partners section */}
                <Partners />

                {/* Contact section */}
                <Contact />
                {/*  Start Your Free Trial Component */}
                <StartYourFreeTrial />

                {/* Footer section */}

                {/* Switcher section */}
                {/* <Switcher /> */}
            </div>

        </>
    );

}
